import { useState } from 'react'
import { Icon, type IconName } from './Icon'

export interface PhotoProps {
  src: string | undefined
  alt: string
  /** Размер значка, который встаёт вместо фото. */
  iconSize: number
  /** Какой значок: у товара — капсула, у категории — баночка. */
  icon?: IconName
}

/**
 * Фото товара. Нет фото или файл не открылся — вместо пустой рамки или
 * значка «битая картинка» встаёт капсула, как у товара без фото.
 */
export function Photo({ src, alt, iconSize, icon = 'i-capsule' }: PhotoProps) {
  const [broken, setBroken] = useState('')
  if (!src || broken === src) return <Icon name={icon} size={iconSize} />
  return (
    <img
      src={src}
      alt={alt}
      className="photo"
      loading="lazy"
      decoding="async"
      onError={() => {
        setBroken(src)
      }}
    />
  )
}
